/**
 * Global Imports
*/

import React from 'react';

/**
 * Root Imports
*/

import * as AbilityServices from '~/services/Ability';
import { ResourcesProvider } from '~/components/Provider';

/**
 * Exports
*/

export const AbilityContext = React.createContext({});

/**
 * 
 */
export function AbilityProvider(props) {
  return (
    <ResourcesProvider name='Ability' context={ AbilityContext } services={ AbilityServices }>
      { props.children }
    </ResourcesProvider>
  );
}